import React from "react";
import styles from './styles.module.scss'
import buttonStyles from '../../components/common/styled/Buttons.module.scss'
import {UserDetails} from "../../actions/api";

import {Button, Form, Input, message, Switch, FormInstance} from 'antd';
import {useAppDispatch} from "../../hooks";
import {updateUser} from "../../actions/userSlice";

export type EditMyAccountProps = {
    form: FormInstance,
    user: UserDetails,
    edit: boolean
    onSave: () => void
    onCancelEdit: () => void
}


export const EditMyAccount = ({form, user, edit, onSave, onCancelEdit}: EditMyAccountProps) => {
    const dispatch = useAppDispatch()

    const onFinish = (values: any) => {
        dispatch(updateUser(values))
            .unwrap()
            .then(() => {
                message.success("Update was successful.")
                onSave()
            })
            .catch(() => {
                message.error("Update failed.")
            })
    }

    /* eslint-disable no-template-curly-in-string */
    const validateMessages = {
        required: '${label} is required.',
        types: {
            email: '${label} is not a valid email.',
        },
        number: {
            range: '${label} must be between ${min} and ${max}',
        }
    }
    /* eslint-enable no-template-curly-in-string */

    const formItemLayout = {
        labelCol: {sm: {span: 6}},
        wrapperCol: {sm: {span: 20}},
    };
    return <div className={styles.fields}>
        <Form name="edit-user-details"
              form={form}
              disabled={!edit}
              initialValues={user}
              onFinish={onFinish}
              validateMessages={validateMessages}
              {...formItemLayout}
              autoComplete="off"
        >
            <Form.Item name="username" hidden={true}>
                <Input/>
            </Form.Item>
            <Form.Item label="Username">{user.username}</Form.Item>

            <Form.Item name="firstName" label="First Name" rules={[{required: true}]}>
                <Input/>
            </Form.Item>
            <Form.Item name="lastName" label="Last Name" rules={[{required: true}]}>
                <Input/>
            </Form.Item>
            <Form.Item name="jobTitle" label="Job Title">
                <Input/>
            </Form.Item>
            <Form.Item name="initialValues" label="Secondary Email" rules={[{type: 'email'}]}>
                <Input/>
            </Form.Item>
            <Form.Item name="workPhone" label="Work Phone">
                <Input/>
            </Form.Item>
            <Form.Item name="mobilePhone" label="Mobile Phone">
                <Input/>
            </Form.Item>
            <Form.Item
                valuePropName={"checked"}
                labelCol={{span: 12}}
                wrapperCol={{span: 12}}
                name={["preferences", "sharingCohortProjects"]} label={"Sharing Projects Email Notifications"}>
                <Switch className={styles['item-right']}/>
            </Form.Item>
            <div className={styles.actions}>
                <Button className={buttonStyles.normal}
                        onClick={onCancelEdit}
                >
                    Cancel
                </Button>
                <Button
                    type="primary"
                    htmlType="submit"
                    className={buttonStyles.primary}
                >
                    Submit
                </Button>
            </div>
        </Form>
    </div>

}